/*
 * Produktbeschreibung einklappbar, angelegt am 11.09.2026.
 * Gegenstück zu hd3d-beschreibung-einklappen.css, dort steht die Begründung.
 *
 * Der Text wird nicht gekürzt, nur visuell begrenzt. Er bleibt vollständig im
 * Quelltext und damit für Suchmaschinen lesbar.
 *
 * Der Knopf erscheint nur, wenn der Text die Grenze wirklich überschreitet.
 * Gemessen wird nach dem Laden der Schriften, weil sich die Texthöhe bis dahin
 * noch ändert.
 */
(function () {
  'use strict';

  var AUFKLAPPEN = 'Mehr lesen';
  var ZUKLAPPEN = 'Weniger anzeigen';
  var TOLERANZ = 24; // Pixel; darunter lohnt der Knopf nicht

  function einrichten(block) {
    if (block.dataset.hd3dKlappBereit === '1') return;

    // Inhalt einpacken, damit der Auslauf-Verlauf einen eigenen Kasten hat.
    var inhalt = document.createElement('div');
    inhalt.className = 'hd3d-klapp__inhalt';
    while (block.firstChild) inhalt.appendChild(block.firstChild);
    block.appendChild(inhalt);

    block.classList.add('hd3d-klapp');
    block.dataset.offen = 'false';
    block.dataset.hd3dKlappBereit = '1';

    var grenze = inhalt.getBoundingClientRect().height;
    var voll = inhalt.scrollHeight;

    // Passt ohnehin: aufräumen und keinen Knopf zeigen.
    if (voll <= grenze + TOLERANZ) {
      block.classList.remove('hd3d-klapp');
      block.removeAttribute('data-offen');
      return;
    }

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'hd3d-klapp__knopf';
    knopf.setAttribute('aria-expanded', 'false');

    var beschriftung = document.createElement('span');
    beschriftung.textContent = AUFKLAPPEN;
    var pfeil = document.createElement('span');
    pfeil.className = 'hd3d-klapp__pfeil';
    pfeil.setAttribute('aria-hidden', 'true');
    knopf.appendChild(beschriftung);
    knopf.appendChild(pfeil);

    // Der Inhalt bekommt eine Kennung, damit der Knopf darauf zeigen kann.
    if (!inhalt.id) {
      inhalt.id = 'hd3d-klapp-' + Math.random().toString(36).slice(2, 9);
    }
    knopf.setAttribute('aria-controls', inhalt.id);

    knopf.addEventListener('click', function () {
      var offen = block.dataset.offen === 'true';
      block.dataset.offen = offen ? 'false' : 'true';
      knopf.setAttribute('aria-expanded', offen ? 'false' : 'true');
      beschriftung.textContent = offen ? AUFKLAPPEN : ZUKLAPPEN;
      // Beim Zuklappen zurück an den Anfang, sonst steht man im Nichts.
      if (offen) {
        var oben = block.getBoundingClientRect().top;
        if (oben < 0) block.scrollIntoView({ block: 'start' });
      }
    });

    block.appendChild(knopf);
  }

  function starten() {
    var bloecke = document.querySelectorAll('.product__block--description');
    for (var i = 0; i < bloecke.length; i++) einrichten(bloecke[i]);
  }

  function los() {
    // Erst nach den Schriften messen, sonst stimmt die Höhe nicht.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(starten);
    } else {
      starten();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }

  // Shopify tauscht bei Variantenwechsel Teile der Seite aus.
  document.addEventListener('shopify:section:load', starten);
})();
